import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { SubCategoryEnum } from '@classifieds-sell/datalayer';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PropertyUiChildRouteGuard implements CanActivate {
    constructor(private _router: Router) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const subCategory: string = next.paramMap.get('subCategory') || '';

        const result = Object.values(SubCategoryEnum).includes(
            subCategory as SubCategoryEnum
        );

        const queryParams = next.queryParams;

        if (!result) {
            // a workaround solution until angular supports it officially
            // more info at https://github.com/angular/angular/issues/27148#issuecomment-831414318
            this._router.currentNavigation()!.extras.skipLocationChange =
                true;

            return this._router.createUrlTree(['404'], { queryParams });
        }

        return true;
    }
}
